import { useMemo } from "react";
import { dateToString } from "../../../lib/dateUtils";
import { IHttpClient } from "../../../lib/http";
import { WaitingListEventType } from "../domain/WaitingListEventType.enum";

export interface WaitingListCountResponse {
  items: number;
}

const getWaitingListCount = async (
  httpClient: IHttpClient,
  propertyTicker: string
): Promise<number> => {
  const response = await httpClient.get<WaitingListCountResponse>(
    `/waiting-list/${propertyTicker}/count`
  );

  return response.items;
};

const getWaitingListReport = async (
  httpClient: IHttpClient,
  propertyTicker: string,
  eventType: WaitingListEventType,
  startDate: Date,
  endDate: Date
): Promise<string> => {
  return await httpClient.get<string>(`/waiting-list/${propertyTicker}/events`, {
    params: {
      type: eventType,
      start: dateToString(startDate, "dd-MM-yyyy"),
      end: dateToString(endDate, "dd-MM-yyyy"),
    },
  });
};

export const useWaitingListReportApi = (client: IHttpClient) => {
  return useMemo(
    () => ({
      getWaitingListCount: (propertyTicker: string) => getWaitingListCount(client, propertyTicker),
      getWaitingListReport: (
        propertyTicker: string,
        eventType: WaitingListEventType,
        startDate: Date,
        endDate: Date
      ) => getWaitingListReport(client, propertyTicker, eventType, startDate, endDate),
    }),
    [client]
  );
};
